import * as types from '../actions/types';

const initState = {
    lastId: 0,
    list: []
};

export default function NotificationsReducer (state = initState, action) {

    switch (action.type)
    {
        case types.NOTIFICATIONS_ADD:
            let newList = [...state.list];
            newList.push({id: state.lastId, type: action.notification.type, text: action.notification.text});
            return { ...state, list: newList, lastId: (state.lastId + 1) };

        case types.NOTIFICATIONS_SET:
            let setList = [{id: state.lastId, type: action.notification.type, text: action.notification.text}];
            return { ...state, list: setList, lastId: (state.lastId + 1) };

        case types.NOTIFICATIONS_REMOVE:
            return { ...state, list: state.list.filter(notification => notification.id !== action.id) };

        case types.NOTIFICATIONS_CLEAR:
            return { ...state, list: [] };

        default:
            return state;
    }

}
